<ap-selector-select
    [label]="'accountSelector.label' | apContent"
    [options]="selectorOptions()"
    [formControl]="control()"
    [selectedOptions]="selectedOptions()"
    [selectionType]="selectionType()"
    [multipleTitle]="'accountSelector.multiple.title'"
    [multipleText]="'accountSelector.multiple.text'"
    [messages]="messages"
    (clicked)="openModal()"
></ap-selector-select>
